import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { brand } from "../config";
import mantisLogoLight from "../Assets/img/mantisBlackLogo.png";
import { getPublicDashboardData } from "../ApiCalls/mantisBusinessPublic";
import "./RenderOrder.scss";

function PublicDashboard() {
  const [isLoading, setIsLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [businessId, setBusinessId] = useState(null);
  const [dashboardId, setDashboardId] = useState(null);

  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const businessId = queryParams.get("businessId");
    const dashboardId = queryParams.get("dashboardId");

    setDashboardData(null);
    setErrorMessage("");
    setIsLoading(true);
    setBusinessId(null);
    setDashboardId(null);

    if (businessId && dashboardId) {
      try {
        setBusinessId(businessId);
        setDashboardId(dashboardId);

        // Fetch dashboard data from API
        const fetchDashboardData = async () => {
          try {
            const dashboardIndex = parseInt(dashboardId) - 1; // Convert to 0-based index
            const response = await getPublicDashboardData(businessId, dashboardIndex);
            
            if (response.success) {
              setDashboardData({
                businessName: response.data.businessName,
                dashboardTitle: response.data.dashboardTitle,
                dashboardUrl: response.data.dashboardUrl,
                businessLogo: response.data.businessLogo
              });
            } else {
              // Set error message if dashboard not found
              setErrorMessage("Dashboard no encontrado");
            }
          } catch (error) {
            console.error("Error fetching dashboard data:", error);
            // Set error message if API call fails
            setErrorMessage("Error al cargar el dashboard. Por favor, verifique que el enlace sea correcto.");
          } finally {
            setIsLoading(false);
          }
        };

        fetchDashboardData();

      } catch (error) {
        console.error("Error processing parameters:", error);
        setErrorMessage(
          `Error al procesar los parámetros de la solicitud: ${
            error.message || "Parámetros inválidos"
          }`
        );
        setIsLoading(false);
      }
    } else {
      setErrorMessage("Faltan parámetros requeridos.");
      setIsLoading(false);
    }
  }, [location.search]);

  if (isLoading) {
    return (
      <div className="render-order-fullscreen">
        <header className="render-order-header" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "20px 40px" }}>
          <img
            src={mantisLogoLight}
            alt={`${brand} Logo`}
            className="mantis-logo"
            style={{ height: "40px" }}
          />
          <h1 className="mantis-title" style={{ margin: "0 0 0 20px", fontSize: "24px" }}>
            Cargando Dashboard...
          </h1>
        </header>
        <main className="render-order-main">
          <div className="loading-section">
            <Spinner animation="border" role="status" />
            <p>Cargando dashboard...</p>
          </div>
        </main>
      </div>
    );
  }

  if (errorMessage) {
    return (
      <div className="render-order-fullscreen">
        <header className="render-order-header" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "20px 40px" }}>
          <img
            src={mantisLogoLight}
            alt={`${brand} Logo`}
            className="mantis-logo"
            style={{ height: "40px" }}
          />
          <h1 className="mantis-title" style={{ margin: "0 0 0 20px", fontSize: "24px" }}>
            Dashboard Público
          </h1>
        </header>
        <main className="render-order-main" style={{ padding: "40px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div className="ipr-status-section" style={{ textAlign: "center", maxWidth: "600px" }}>
            <div className="error-message" style={{ padding: "40px", backgroundColor: "#f8f9fa", borderRadius: "8px", border: "1px solid #dee2e6" }}>
              <div>
                <h3 style={{ color: "#dc3545", marginBottom: "20px" }}>⚠️ Dashboard no disponible</h3>
                <p style={{ fontSize: "16px", color: "#6c757d", marginBottom: "20px" }}>{errorMessage}</p>
                <div style={{ fontSize: "14px", color: "#868e96" }}>
                  <p><strong>Business ID:</strong> {businessId}</p>
                  <p><strong>Dashboard ID:</strong> {dashboardId}</p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="render-order-fullscreen">
      <header className="render-order-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "20px 40px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <img
            src={mantisLogoLight}
            alt={`${brand} Logo`}
            className="mantis-logo"
            style={{ height: "40px" }}
          />
          {dashboardData.businessLogo && (
            <img
              src={dashboardData.businessLogo}
              alt="Business Logo"
              style={{ height: "60px", maxWidth: "300px", objectFit: "contain" }}
            />
          )}
        </div>
        <h1 className="mantis-title" style={{ margin: 0, fontSize: "24px" }}>
          {dashboardData.dashboardTitle}
        </h1>
      </header>
      <main className="render-order-main" style={{ padding: "0", margin: "0" }}>
        <div style={{ width: "100%", height: "calc(100vh - 80px)", padding: "0" }}>
          <iframe
            title={dashboardData.dashboardTitle}
            width="100%"
            height="100%"
            src={dashboardData.dashboardUrl}
            frameBorder="0"
            allowFullScreen
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            style={{ border: "none" }}
          ></iframe>
        </div>
      </main>
    </div>
  );
}

export default PublicDashboard;
